// Données vivantes pour la page d'accueil

// Images Unsplash vérifiées (libres usage commercial)
export const HERO_IMAGE = 'https://images.unsplash.com/photo-1741542303195-dafb546d9b1e?w=2400&q=80&auto=format&fit=crop';

export const FORMATION_IMAGES = {
  'AM / BSR': 'https://images.unsplash.com/photo-1722217678977-6ab2d1a10b38?w=1200&q=75&auto=format&fit=crop', // scooter urbain moderne
  'A1': 'https://images.unsplash.com/photo-1599360687378-5f8355df9bd5?w=1200&q=75&auto=format&fit=crop', // man red jacket moto
  'A2': 'https://images.unsplash.com/photo-1608501622839-8a8955239276?w=1200&q=75&auto=format&fit=crop', // man black jacket sunset
  'Passerelle A2 vers A': 'https://images.unsplash.com/photo-1544148024-c3759a58ba99?w=1200&q=75&auto=format&fit=crop', // 2 persons mountain
  'Formation 125 (B→A1)': 'https://images.unsplash.com/photo-1582340172451-b4ee5b61e974?w=1200&q=75&auto=format&fit=crop', // yellow motorcycle sunset
  'L5e / Ryker 600-900': '/brand/ryker-llb.jpg', // Photo perso Ryker LLB ECSR
  'Études de cas CCS': 'https://images.unsplash.com/photo-1544141687-4a0477ba4ccc?w=1200&q=75&auto=format&fit=crop', // golden hour
};

// Chiffres ONISR — Baromètre juillet 2026 (12 mois glissants)
export const SECURITE_ROUTIERE = {
  year: 2026,
  dead_2roues: 682,
  dead_evolution: '−3 % vs 12 mois précédents (−9 % vs 2019)',
  share_dead: 22,
  share_trafic: 2,
  injured_serious: 5300,
  injured_evolution: '+3 % sur 12 mois',
  source: 'ONISR — Baromètre juillet 2026',
  message: 'Les usagers de 2 roues représentent ~22 % des tués pour moins de 2 % du trafic. En juillet 2026, +7 motards tués sur le mois : la vigilance reste vitale.'
};

// Calendrier MotoGP 2026 (dates officielles provisoires)
export const MOTOGP_2026 = [
  { round: 1, date: '2026-03-01', country: 'Thaïlande', city: 'Buriram', flag: '🇹🇭' },
  { round: 2, date: '2026-03-08', country: 'Argentine', city: 'Termas de Río Hondo', flag: '🇦🇷' },
  { round: 3, date: '2026-03-29', country: 'États-Unis', city: 'Austin · COTA', flag: '🇺🇸' },
  { round: 4, date: '2026-04-12', country: 'Qatar', city: 'Losail', flag: '🇶🇦' },
  { round: 5, date: '2026-04-26', country: 'Espagne', city: 'Jerez', flag: '🇪🇸' },
  { round: 6, date: '2026-05-10', country: 'France', city: 'Le Mans', flag: '🇫🇷' },
  { round: 7, date: '2026-05-24', country: 'Italie', city: 'Mugello', flag: '🇮🇹' },
  { round: 8, date: '2026-06-07', country: 'Catalogne', city: 'Barcelone', flag: '🇪🇸' },
  { round: 9, date: '2026-06-21', country: 'Pays-Bas', city: 'Assen', flag: '🇳🇱' },
  { round: 10, date: '2026-07-05', country: 'Allemagne', city: 'Sachsenring', flag: '🇩🇪' },
  { round: 11, date: '2026-08-02', country: 'République tchèque', city: 'Brno', flag: '🇨🇿' },
  { round: 12, date: '2026-08-16', country: 'Autriche', city: 'Red Bull Ring', flag: '🇦🇹' },
  { round: 13, date: '2026-08-30', country: 'Hongrie', city: 'Balaton Park', flag: '🇭🇺' },
  { round: 14, date: '2026-09-13', country: 'Saint-Marin', city: 'Misano', flag: '🇸🇲' },
  { round: 15, date: '2026-09-27', country: 'Japon', city: 'Motegi', flag: '🇯🇵' },
  { round: 16, date: '2026-10-11', country: 'Indonésie', city: 'Mandalika', flag: '🇮🇩' },
  { round: 17, date: '2026-10-25', country: 'Australie', city: 'Phillip Island', flag: '🇦🇺' },
  { round: 18, date: '2026-11-08', country: 'Malaisie', city: 'Sepang', flag: '🇲🇾' },
  { round: 19, date: '2026-11-22', country: 'Portugal', city: 'Portimão', flag: '🇵🇹' },
  { round: 20, date: '2026-11-29', country: 'Espagne', city: 'Valence', flag: '🇪🇸' },
];

export function getNextMotoGP(now = new Date()) {
  const next = MOTOGP_2026.find(gp => new Date(gp.date) >= now);
  return next || MOTOGP_2026[0]; // fallback au premier GP de 2026 si on est avant
}

export function daysUntil(dateStr, now = new Date()) {
  const ms = new Date(dateStr).getTime() - now.getTime();
  return Math.max(0, Math.ceil(ms / (1000 * 60 * 60 * 24)));
}
